import { ROUTES } from '@/constants';

// The policy pages moved from /other-policies/* on 2026-10-28. Old bookmarks land here.
const LEGACY_POLICY_PATHS: ReadonlyArray<readonly [RegExp, (stationId: string) => string]> = [
  [
    /^\/other-policies\/office-hours\/([^/]+)\/edit\/?$/,
    (id) => `/policies/opening-hours/${id}/edit`,
  ],
  [/^\/other-policies\/office-hours\/?$/, () => ROUTES.OFFICE_HOURS],
  [/^\/other-policies\/extra-driver\/?$/, () => ROUTES.EXTRA_DRIVERS],
  [/^\/other-policies\/age-limits\/?$/, () => ROUTES.DRIVER_AGE],
  [/^\/other-policies\/road-assistance\/?$/, () => ROUTES.ROAD_ASSISTANCE],
  [/^\/other-policies\/km-policies\/?$/, () => ROUTES.KM_POLICIES],
  [/^\/other-policies\/discounts\/?$/, () => ROUTES.DISCOUNTS],
  [/^\/other-policies\/rental-duration\/?$/, () => ROUTES.RENTAL_DURATION],
];

/** The new path for an old /other-policies path. Anything unknown goes to the Setup page. */
export const legacyPolicyPath = (pathname: string): string => {
  for (const [pattern, toPath] of LEGACY_POLICY_PATHS) {
    const match = pattern.exec(pathname);
    if (match) return toPath(match[1] ?? '');
  }
  return ROUTES.SETUP;
};
